import { cliente } from '@/lib/cliente';
import type { ListaBatchesResponse, ListarBatchesRequest, RespuestaApi } from '@adelante/shared';
import { useQuery } from '@tanstack/react-query';

/**
 * Listado de batches con datos crudos de planta (vista de análisis).
 * La key incluye todos los filtros para que TanStack distinga combinaciones.
 */
export function useBatchesDetalle(filtros: Partial<ListarBatchesRequest>) {
  return useQuery<RespuestaApi<ListaBatchesResponse>>({
    queryKey: ['batches-detalle', filtros],
    queryFn: () => cliente.batches.listar(filtros),
  });
}
